import { Migration } from "@mydocma/core/src/lib/migration";
import { IDBPDatabase } from "idb";
import { MmProjectDbCollections } from "../../mm-project-db-schema";

export const V6: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmProjectDbCollections.projectSettings,  { keyPath: 'Key' });
  },

};
